/** Harga ditentukan jumlah tamu saja (Rupiah). Foto per orang bebas dipilih, tidak memengaruhi harga. */
export const GUEST_TIERS = {
  10: 99000,
  50: 199000,
  100: 299000,
  200: 499000,
  500: 999000,
  1000: 1499000,
} as const;

/** Uji coba gratis: satu per akun, 5 tamu, album aktif 14 hari. */
export const TRIAL = { guests: 5, photos_per_guest: 10, days: 14 } as const;

export const PHOTOS_PER_GUEST = [5, 10, 16, 24, 36] as const;

export const TOPUP = { photo_100: 49000, device_50: 39000, extend_30d: 59000 } as const;

export type GuestTier = keyof typeof GUEST_TIERS;
export type PhotosPerGuest = (typeof PHOTOS_PER_GUEST)[number];

export const rupiah = (n: number) => `Rp${n.toLocaleString("id-ID")}`;

export const isTier = (v: unknown): v is GuestTier => typeof v === "number" && v in GUEST_TIERS;
export const isPhotosPerGuest = (v: unknown): v is PhotosPerGuest =>
  typeof v === "number" && (PHOTOS_PER_GUEST as readonly number[]).includes(v);
